import {Component, forwardRef, OnInit} from '@angular/core';
import {Field} from "../../field";
import {Settings} from "../../../../multiselect/multiselect.config";

@Component({
	selector: 'tig-assignment-select-multiple-check', template: `
    <div
        class="form-group"
        [ngClass]="{'has-error': isInvalid()}">
      <label class="col-lg-3 control-label" [ngClass]="{'tgi-required': isRequired()}">{{getLabelName()|translate}}
        <i *ngIf="getHint()" class="fa fa-info-circle"
           tooltip="{{getHint()|translate}}"
           placement="top"
           triggers="click"
           containerClass="tig-tooltip"
           delay="50"></i>
        <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
      <div class="col-lg-8">
        <tig-multiselect
            [items]="OBJ_field_config.options"
            [settings]="OBJ_settings"
            [disabled]="OBJ_field_config?.readonly"
            [(ngModel)]="OBJ_data.ids"
        ></tig-multiselect>
        <span class="help-block m-b-none" *ngIf="isInvalid()">
		  {{'oError.sRequired'|translate}}
		</span>
      </div>
    </div>
	`, providers: [{provide: Field, useExisting: forwardRef(() => AssignmentSelectMultipleCheckComponent)}]
})
export class AssignmentSelectMultipleCheckComponent extends Field implements OnInit {


	/**
	 * Attributes
	 */
		// Settings configuration
	OBJ_settings: Settings = {
		id: "id", // attribute name in object for the identifier
		text: "title", // attribute name in object for the text
		enableFilter: true, placeholder: "please_select", filterPlaceholder: "filter", multiple: false, options: null
	};


	/**
	 * Function > ngOnInit
	 */
	ngOnInit() {

		this.OBJ_settings.multiple = (this.OBJ_field_config.multiple != null) ? this.OBJ_field_config.multiple : true;
		this.OBJ_settings.options = (this.OBJ_field_config._links.options != null) ? this.OBJ_field_config._links.options : null;
	} // end function ngOnInit


	/**
	 * Function > isInvalid
	 */
	isInvalid(): boolean {
		if (this.isRequired()) {
			return this.OBJ_data.ids.length === 0;
		} // end if

		return false;
	} // end function isInvalid


} // end class AssignmentSelectMultipleCheckComponent
